import React from 'react';
import { EditableInfoBlockStyled } from './styles';

interface Props {
  groupSize: string;
  onEdit: () => void;
}

export const ExpectedGroupSizeInfoBlock: React.FC<Props> = ({ groupSize, onEdit }) => {
  return (
    <EditableInfoBlockStyled
      title={`Expected number of employees: ${groupSize}`}
      actionName="Edit"
      onEditInfo={onEdit}
    />
  );
};
